import React from "react";

export default class WebCnDevice extends React.Component {
  render() {
    const { Bs, VARIANT } = this.props;
    return (
      <Bs col xs={12} md={6} lg={4} className="mb-4">
        <Bs row className="mb-2">
          <Bs b>Přístroj</Bs>
        </Bs>
        <Bs row>
          <Bs small>
            <Bs b>IMEI </Bs> 325156521541541
          </Bs>
        </Bs>
        <Bs row>
          <Bs small>
            <Bs b>SN </Bs> FR8484848488
          </Bs>
        </Bs>
        <Bs row>
          <Bs small>
            <Bs b>VÝROBCE </Bs> FR8484848488
          </Bs>
        </Bs>
        <Bs row>
          <Bs small>
            <Bs b>TYP </Bs> FR8484848488
          </Bs>
        </Bs>
      </Bs>
    );
  }
}
